import { useNavigate } from 'react-router-dom'
 import "./App.css"
const NotFound = () => {
    const navigate = useNavigate()
    return (
        <div className="notFound d-flex align-items-center justify-content-center" style={{height:"100vh"}}>
            <div className='text-center'>
                <h1 className="notFound-error">404</h1>
                <div className="notFound-text">Ooops!!! The page you are looking for is not found.</div>
                <button className="back-home text-uppercase" onClick={() => navigate("/home")}>Back to home</button>
            </div>
        </div>

    )
}

export default NotFound
